/**
 * Copyright (c) 2025 eBUCIS, LLC. All rights reserved.
 *
 * Modal Portal - Safe portal implementation for modals
 *
 * This software is proprietary and confidential. Unauthorized copying,
 * distribution, or modification is strictly prohibited.
 */

import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

const ModalPortal = ({ children, id = 'modal-root' }) => {
  const [mounted, setMounted] = useState(false)
  const [modalRoot, setModalRoot] = useState(null)

  useEffect(() => {
    // Find or create modal root
    let root = document.getElementById(id)

    if (!root) {
      root = document.createElement('div')
      root.id = id
      document.body.appendChild(root)
    }

    setModalRoot(root)
    setMounted(true)

    // Cleanup function
    return () => {
      // Only remove if we created it and it's empty
      if (root && root.childNodes.length === 0 && root.id !== 'modal-root') {
        // Check if element still exists in DOM before removing
        if (document.body.contains(root)) {
          document.body.removeChild(root)
        }
      }
    }
  }, [id])

  // Don't render until mounted
  if (!mounted || !modalRoot) {
    return null
  }

  return createPortal(children, modalRoot)
}

export default ModalPortal
